import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const RentMachineRow = ({rent, onDelete, intl}) => {
    return (
        <tr key={rent.id}>
            <td scope="row" className="align-middle">{rent.id}</td>
            <td className="align-middle">{
                rent.image
                    ? <img width="100px" src={rent.image.filePath} />
                    : 'no photo'

            }</td>
            <td className="align-middle">{rent.name}</td>
            <td className="align-middle">{rent.category.name}</td>
            <td className="align-middle">{rent.price}</td>
            <td className="align-middle">{rent.quantity}</td>
            <td className="list-actions text-right align-middle">
                <div className="btn-group text-right">
                    <Link to={'/rent/redigere/'+rent.id}
                          className="btn btn-secondary waves-effect list-action"
                    >
                        <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                    </Link>
                    <button
                        type="button"
                        className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                    </button>
                    <div className="dropdown-menu">
                        <button type="button"
                                className="dropdown-item clickable"
                                onClick={() => onDelete(rent.id)}
                        >
                            <i className="fa fa-trash-o"/>{intl.formatMessage(messages.listDropDownButtonDelete)}
                        </button>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default injectIntl(RentMachineRow);



// WEBPACK FOOTER //
// ./web/src/components/machine-rental/RentMachineRow.jsx